import { render } from "./MatchBracket.vue?vue&type=template&id=16ece403&scoped=true&ts=true"
import script from "./MatchBracket.vue?vue&type=script&lang=ts"
export * from "./MatchBracket.vue?vue&type=script&lang=ts"

import "./MatchBracket.vue?vue&type=style&index=0&id=16ece403&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ece403"]])

export default __exports__